import Vue from 'vue'
// axios
import axios from 'axios'


const VECCHIO_IMPORTO_MULTIPLIER = 0.2
const VECCHIO_IMPORTO_DEFAULT = 1000

Vue.prototype.$tariffe = {
  // bool == 1 per calcolo tariffe, bool == 0 per calcolo preventivo
  calcolaVoce(voce,bool,vecchio_importo = VECCHIO_IMPORTO_DEFAULT) {
    let voce_ = 0
    let num_scaglioni = voce.tariffa_applicata.scaglioni.length
    // console.log(vecchio_importo == 1000 ? {res:'si',v:voce,b:bool,old:vecchio_importo} : {res:'no',v:voce,b:bool,old:vecchio_importo});
    if (voce.tariffa_applicata.quantifier == 'x') return vecchio_importo*VECCHIO_IMPORTO_MULTIPLIER
    if (bool) {
     // if (voce.tariffa_applicata.durata == 1 || voce.tariffa_applicata.quantifier == 's' ) return voce.preventivato
     if(voce.tariffa_applicata.quantifier == 'q' && voce.tariffa_applicata.scaglioni.length == 1) {
       voce_ = (voce.preventivato*12/voce.tariffa_applicata.durata)*voce.quantita
     } else{
       if (voce.tariffa_applicata.quantifier == 's' || (voce.tariffa_applicata.quantifier == 'q' && voce.tariffa_applicata.servizio.codice != 'Paghe')) return voce.preventivato
       voce_ = (voce.preventivato*12/voce.tariffa_applicata.durata)*voce.quantita
     }
     return voce_
    } else {
      if(voce.tariffa_applicata.quantifier == 'q' && voce.tariffa_applicata.scaglioni.length == 1) {
        voce_ = (voce.tariffa_applicata.scaglioni.find( s => {
          if (s.min_q <= voce.quantita && s.max_q >= voce.quantita) return s
        }).importo*12/voce.tariffa_applicata.durata)*voce.quantita
      } else {
        if (voce.tariffa_applicata.quantifier == 's' || (voce.tariffa_applicata.quantifier == 'q' && voce.tariffa_applicata.servizio.codice != 'Paghe' && voce.tariffa_applicata.scaglioni.length > 1))
        return voce.tariffa_applicata.scaglioni.find( s => {
          if (s.min_q <= voce.quantita && s.max_q >= voce.quantita) return s
        }).importo
        voce_ = (voce.tariffa_applicata.scaglioni.find( s => {
          if (s.min_q <= voce.quantita && s.max_q >= voce.quantita) return s
        }).importo*12/voce.tariffa_applicata.durata)*voce.quantita
      }
      return voce_
    }
  },

  calcolaScontoVoce(voce,vecchio_importo = VECCHIO_IMPORTO_DEFAULT) {
    if (this.calcolaVoce(voce,0,vecchio_importo) == 0) return 0
    let res = (( this.calcolaVoce(voce,1,vecchio_importo) - this.calcolaVoce(voce,0,vecchio_importo) ) / this.calcolaVoce(voce,0,vecchio_importo)) * 100
    return res ? res : 0
  },

  calcolaScontoPreventivo(voci,vecchio_importo = VECCHIO_IMPORTO_DEFAULT) {
    let res = (this.calcolaPreventivo(voci,1,vecchio_importo) - this.calcolaPreventivo(voci,0,vecchio_importo)) / this.calcolaPreventivo(voci,0,vecchio_importo) * 100
    return res ? res : 0
  },

  calcolaPreventivo(voci,bool,vecchio_importo = VECCHIO_IMPORTO_DEFAULT) {
    let preventivato_ = 0
    if (bool) {
      voci.forEach( (e) => {
        if (e.tariffa_applicata.quantifier != '0' && e.tariffa_applicata.quantifier != 'u' ) {
          if (e.quantita > 0 && e.preventivato > 0) {
            preventivato_ += this.calcolaVoce(e,1,vecchio_importo)
          }
        }
      })
      // console.log(bool,' BOOL TARIFFE: ',preventivato_);
      return preventivato_
    } else {
      voci.forEach( (e) => {
        if (e.tariffa_applicata.quantifier != '0' && e.tariffa_applicata.quantifier != 'u' ) {
          if (e.quantita > 0 && e.preventivato > 0) {
            preventivato_ += this.calcolaVoce(e,0,vecchio_importo)
          }
        }
      })
      // console.log(bool,' NOT BOOL PREVENTIVO: ',preventivato_);
      return preventivato_
    }
  },

  formatDate(date) {
    date = new Date(date)
    return date.getDate()+'-'+(((date.getMonth()+1) < 10) ? '0'+(date.getMonth()+1) : (date.getMonth()+1))+'-'+date.getFullYear()
  },

  formatDateNew(date) {
    if (!date) return ''
    date = new Date(date)
    var options = { year: "numeric", month: "short", day: "numeric" }
    return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
  },

  async generatePDFazienda(p_to_print) {
    let uff = null
    if (p_to_print.codice_ufficio) {
      let uffici = await this.getUffici()
      uff = uffici.find( el => el.codice == p_to_print['codice_ufficio'])
    }
    if (p_to_print.contatti) {
        p_to_print.contatti.forEach( el => {
          el['contatto']['data_nascita'] = this.formatDateNew(el['contatto']['data_nascita'])
        });
    } else {
      p_to_print.data_nascita = this.formatDateNew(p_to_print.data_nascita)
    }
    return {preventivo: { azienda: p_to_print }, codice_ufficio: uff ? [uff.descrizione,' (',uff.codice,')'].join('') : '' }
  },

  generatePDFpreventivo(p_to_print) {
    p_to_print['logo'] = this.returnLogoString(p_to_print)
    p_to_print['logo_string'] = this.returnLogoString(p_to_print)
    // let voce = p_to_print.voci[0]
    // p_to_print['tariffa'] = this.returnLogoString(voce['tariffa_applicata']['tariffa']['nome'])
    // p_to_print['servizio'] = this.returnLogoString(voce['tariffa_applicata']['servizio']['codice'])
    p_to_print['data_emissione'] = this.formatDateNew(p_to_print['data_emissione'])
    p_to_print['data_scadenza'] = this.formatDateNew(p_to_print['data_scadenza'])
    if (p_to_print['data_vecchio']) {
      p_to_print['data_vecchio'] = this.formatDateNew(p_to_print['data_vecchio'])
    }
    p_to_print['importo_finale'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(p_to_print['importo_finale'])
    p_to_print['importo_vecchio'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(p_to_print['importo_vecchio'])
    if (p_to_print.azienda && p_to_print.azienda.id) {
        p_to_print.azienda.contatti.forEach( el => {
          el['contatto']['data_nascita'] = this.formatDateNew(el['contatto']['data_nascita'])
        });
    }
    let tar = ''
    let serv = ''
    p_to_print.voci.forEach(e => {
      tar = e.tariffa_applicata.tariffa.nome
      serv = e.tariffa_applicata.servizio.codice
      let scaglione_index = e.tariffa_applicata.scaglioni.findIndex( el => {
        if (el.min_q <= e.quantita && el.max_q >= e.quantita) return el
      })
      e['tariffa'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format((+e.tariffa_applicata.scaglioni[scaglione_index].importo))
      e['totale_preventivato'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(this.calcolaVoce(e,1,p_to_print['importo_vecchio']))
      e['totale_tariffa'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(this.calcolaVoce(e,0,p_to_print['importo_vecchio']))
      if (e['tariffa']) e['tariffa'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(+e['tariffa'])
      e['preventivato'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(+e['preventivato'])
    })
    p_to_print = this.sortVoci(p_to_print)

    p_to_print['tariffa'] = tar
    p_to_print['servizio'] = serv
    return p_to_print
  },

  async generatePDFcontratto(p_to_print) {
    p_to_print['logo'] = this.returnLogoString(p_to_print.preventivo)
    p_to_print['data_emissione'] = this.formatDateNew(p_to_print['data_emissione'])
    p_to_print['data_decorrenza'] = this.formatDateNew(p_to_print['data_decorrenza'])
    p_to_print['adesione_data'] = this.formatDateNew(p_to_print['adesione_data'])
    p_to_print['appendice_data'] = this.formatDateNew(p_to_print['appendice_data'])
    p_to_print['privacy_data'] = this.formatDateNew(p_to_print['privacy_data'])
    // console.log('contrattooo:   ',p_to_print.addebito_iban);
    if (p_to_print['antiric_soci']) {
      p_to_print.antiric_soci = p_to_print.antiric_soci.filter( socio => typeof socio == "object")
      p_to_print.antiric_soci.forEach( socio => {
        socio.data_scadenza = this.formatDateNew(socio.data_scadenza)
        socio.data_nascita = this.formatDateNew(socio.data_nascita)
      })
      let l = p_to_print.antiric_soci.length
      p_to_print['antiric_titolare'] = p_to_print.antiric_soci[l-1]
      p_to_print['antiric_soci'] = p_to_print.antiric_soci.slice(0,l-1)
    }
    if (p_to_print['addebito_iban']) {

      p_to_print['addebito_iban_sottoscritto'] = (p_to_print.preventivo.azienda.tipo_azienda == 'DITTA IND.' ) ||
                                    ( p_to_print.preventivo.azienda.contatti &&
                                    p_to_print.preventivo.azienda.contatti.find(c => c.id_ruolo == 93 || c.id_ruolo == 1).contatto.codice_fiscale == p_to_print.addebito_codice_fiscale
                                    ) ? true : false

      p_to_print['addebito_iban_paese'] = p_to_print.addebito_iban.substr(0,2)
      p_to_print['addebito_iban_cin_eu'] = p_to_print.addebito_iban.substr(2,2)
      p_to_print['addebito_iban_cin_it'] = p_to_print.addebito_iban.substr(4,1)
      p_to_print['addebito_iban_abi'] = p_to_print.addebito_iban.substr(5,5)
      p_to_print['addebito_iban_cab'] = p_to_print.addebito_iban.substr(10,5)
      p_to_print['addebito_iban_conto'] = p_to_print.addebito_iban.substr(15)

      let bank = await this.getEstremiBanca(p_to_print)
      // console.log('Banca da Iban: ',bank)

      p_to_print['addebito_iban_banca'] = (bank && bank['abi']) ? bank['abi']['abidsbanca'] : ''
      p_to_print['addebito_iban_agenzia'] = (bank && bank['cab']) ? bank['cab']['cabsportello'] : ''
    }
    p_to_print['templates'] = p_to_print['templates'].filter( t => t.attivo ).sort(function(a, b){return a.posizione-b.posizione})
    p_to_print.preventivo = this.generatePDFpreventivo(p_to_print.preventivo)

    return p_to_print
  },

  generatePDFaddebito(p_to_print) {
    p_to_print['logo'] = this.returnLogoString(p_to_print)
    p_to_print['logo_string'] = this.returnLogoString(p_to_print)
    p_to_print['data_emissione'] = this.formatDateNew(p_to_print['data_emissione'])
    p_to_print['data_scadenza'] = this.formatDateNew(p_to_print['data_scadenza']) // this is missing but results empty instead of undefined
    if (p_to_print['data_vecchio']) {
      p_to_print['data_vecchio'] = this.formatDateNew(p_to_print['data_vecchio'])
    }
    p_to_print['importo_finale'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(p_to_print['importo_finale'])
    if (p_to_print.azienda && p_to_print.azienda.id) {
        p_to_print.azienda.contatti.forEach( el => {
          el['contatto']['data_nascita'] = this.formatDateNew(el['contatto']['data_nascita'])
        });
    }
    let tar = ''
    let serv = ''
    p_to_print.voci.forEach(e => {
      tar = e.tariffa_applicata.tariffa.nome
      serv = e.tariffa_applicata.servizio.codice
      let scaglione_index = e.tariffa_applicata.scaglioni.findIndex( el => {
        if (el.min_q <= e.quantita && el.max_q >= e.quantita) return el
      })
      // something wrong with e['tariffa], it's always "NaN"
      e['tariffa'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format((+e.tariffa_applicata.scaglioni[scaglione_index].importo))
      e['totale_preventivato'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(this.calcolaVoce(e,1,0))
      e['totale_tariffa'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(this.calcolaVoce(e,0,0))
      if (e['tariffa']) e['tariffa'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(+e['tariffa'])
      e['preventivato'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(+e['preventivato'])
    })
    p_to_print = this.sortVoci(p_to_print)

    p_to_print['tariffa'] = tar
    p_to_print['servizio'] = serv
    p_to_print['responsabile'] = p_to_print['operatore']
    return p_to_print
  },

  checkLogo(voci) {
    let logo = ""
    voci.forEach( v => {
      if (v.tariffa_applicata.logo)
      logo = v.tariffa_applicata.logo
    })
    return logo
  },

  getLoghi(voci) {
    let loghi = voci.map( v => v.tariffa_applicata.logo)
    return loghi
  },

  checkServizio(voci) {
    if (voci.length) return voci[0].tariffa_applicata.servizio.codice
  },

  returnLogoString(preventivo) {
    let serv = this.checkServizio(preventivo.voci)
    let loghi = this.getLoghi(preventivo.voci)
    // per ogni Tirocinio => ISCOM
    // per ogni Associazione => CONFCOMMERCIO
    // altrimenti sarebbe da controllare lista loghi? come gestisci due elementi uno CONFCOMMERCIO altro CEDASCOM? da chiedere
    if (loghi.includes('TIROCINIO') || loghi.includes('ISCOM')) return 'ISCOM'
    else return (serv == "Associazione") ? "CONFCOMMERCIO" : "CEDASCOM"
  },

  returnLogoString_OLD(preventivo) {
    if (!(preventivo.azienda && preventivo.azienda.stato == 'SOCIO')) {
      return "CONFCOMMERCIO"
    } else {
      return (this.checkLogo(preventivo.voci) == "ISCOM") ? "ISCOM" :
            this.checkLogo(preventivo.voci) == "TIROCINIO" ? "ISCOM" :
            (this.checkLogo(preventivo.voci) == 'CEDASCOM') ? "CEDASCOM" :
            "CONFCOMMERCIO"
    }
  },

  async getEstremiBanca(p_to_print) {
    return axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/get_banca_details', {"abi": p_to_print['addebito_iban_abi'],"cab": p_to_print['addebito_iban_cab']},
              {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
    }).then(response => {
      return response.data
    }).catch(e => console.log(e))
  },

  sortVoci(prev) {
    // console.log(prev);
    function compare_n(a, b) {
      const position_a = a.tariffa_applicata.weight
      const name_a = a.tariffa_applicata.nome.toUpperCase()
      const position_b = b.tariffa_applicata.weight
      const name_b = b.tariffa_applicata.nome.toUpperCase()

      let comparison = 0;
      if (position_a > position_b) {
        comparison = 1;
      } else if (position_a < position_b) {
        comparison = -1;
      } else {
        if (name_a > name_b) comparison = 1
        else comparison = -1
      }
      return comparison;
    }
    prev.voci.sort(compare_n)
    // prev.forEach( (v,i) => {
    //   console.log('Position: ',i,' weight: ',v.  tariffa_applicata.weight,' Nome: ',v.tariffa_applicata.nome);
    // });
    // console.log(prev);

    return prev
  },

  async getUffici() {
    return axios.get(process.env.VUE_APP_BACKEND_API+'/azienda/get_uffici',
          {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
      }).then(response => {
              return response.data
      }).catch(e => console.log(e))
  },

 }
